import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import FieldSelect from '../../../../../components/general/fields/fieldSelect';
import { useAccountContactPerson } from './hook';
import { AccountContactPersonProps } from './props';

export const AccountContactPerson = (props: AccountContactPersonProps) => {
    const { formik, typesDocument } = useAccountContactPerson(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12} sm={12}>
                <FieldText
                    label="Nombre y Apellidos"
                    name="name"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FieldSelect
                    data={typesDocument}
                    label="Tipo de documento"
                    name="typeDocument"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.typeDocument}
                    errors={formik.errors.typeDocument}
                    value={formik.values.typeDocument as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Identificación"
                    name="document"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.document}
                    errors={formik.errors.document}
                    value={formik.values.document}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <FieldText
                    label="Celular"
                    name="cellPhone"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.cellPhone}
                    errors={formik.errors.cellPhone}
                    value={formik.values.cellPhone}
                    onChange={formik.handleChange}
                />
            </Grid>
        </Grid>
    );
};
